import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import { Analytics } from "@vercel/analytics/react";
import i18n from "@/lib/i18n";
import { initSentry } from "@/lib/sentry";
import { AppRouter } from "@/router";
import { PersonalizationProvider } from "@/contexts/PersonalizationContext";
import "@/styles/globals.css";
import "@/styles/rc/index.css";

initSentry();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <PersonalizationProvider>
            <AppRouter />
            <Analytics />
          </PersonalizationProvider>
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
